// extracted by mini-css-extract-plugin
export default {"header":"CustomerNoteDetails_header__6Ckdn","content":"CustomerNoteDetails_content__fR4SE","wrapper":"CustomerNoteDetails_wrapper__zuO7M"};